import { Primitive, primitives } from 'types/primitive'

export const isPrimitive = (value: string): value is Primitive =>
  primitives.findIndex((p: Primitive): boolean => p === value) != -1
